import { css } from "styled-components";

var borderToneColors = function borderToneColors(props) {
  var constants = css(["transition:border 120ms ease-in-out,box-shadow 120ms ease-in-out;border-radius:8px;&:hover{border:1px solid ", ";}&:focus{box-shadow:0 0 0px 3px ", ";}"], function (props) {
    return props.theme.colors.black;
  }, function (props) {
    return props.theme.formFocusColor;
  });

  switch (props.tone) {
    case "danger":
      return css(["border:1px solid ", ";", ""], function (props) {
        return props.theme.dangerMedium;
      }, constants);
    default:
      // "neutral" | "warning" | "success"
      return css(["border:1px solid ", ";", ""], function (props) {
        return props.theme.formBorderColor;
      }, constants);
  }
};

export var formStyleMixins = {
  borderToneColors: borderToneColors
};